import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { db } from "../firebase.js";
import { ref, onValue, set, update, remove } from "firebase/database";

let unsubscribe = null;

export const subscribeProducts = () => (dispatch) => {
  if (!db) return;
  if (unsubscribe) unsubscribe();

  unsubscribe = onValue(
    ref(db, "products"),
    (snapshot) => {
      if (snapshot.exists()) {
        const val = snapshot.val();
        const list = Object.keys(val).map((k) => ({ id: k, ...val[k] }));
        dispatch(setProducts(list));
      } else {
        dispatch(setProducts([]));
      }
    },
    (error) => console.error("Products listener error:", error.message)
  );
};

export const fetchProducts = () => subscribeProducts();

export const createProduct = createAsyncThunk("products/create", async (product) => {
  const productId = `prod_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  const productData = { id: productId, ...product, createdAt: Date.now() };
  await set(ref(db, `products/${productId}`), productData);
  return productData;
});

export const updateProduct = createAsyncThunk("products/update", async ({ id, data }) => {
  await update(ref(db, `products/${id}`), { ...data, updatedAt: Date.now() });
  return { id, ...data };
});

export const deleteProduct = createAsyncThunk("products/delete", async (id) => {
  await remove(ref(db, `products/${id}`));
  return id;
});

const productsSlice = createSlice({
  name: "products",
  initialState: { items: [], status: "idle", error: null },
  reducers: {
    setProducts(state, action) {
      state.items = action.payload;
      state.status = "succeeded";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProduct.rejected, (state, a) => { state.error = a.error.message; })
      .addCase(updateProduct.rejected, (state, a) => { state.error = a.error.message; })
      .addCase(deleteProduct.rejected, (state, a) => { state.error = a.error.message; });
  },
});

export const { setProducts } = productsSlice.actions;
export default productsSlice.reducer;
